import styles from './NodeConnector.module.scss'

function NodeConnector({ hasArrow = false, isDisabledByPrevious = false }) {
  const connectorClassName = isDisabledByPrevious
    ? `${styles.connector} ${styles.disabledByPrevious}`
    : styles.connector

  return (
    <div className={connectorClassName}>
      <div className={styles.connectorInner}>
        <div className={hasArrow ? styles.lineWithArrow : styles.line} />
        {hasArrow && (
          <svg
            className={styles.arrow}
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L6 6L11 1"
              stroke="#d1d5db"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
    </div>
  )
}

export default NodeConnector
